import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Backdrop } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import "../../CSS/Projects.css";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    position: "absolute",
    transition: " all 0.5s ease",
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

export default function ProjectBox(props) {
  const projectInfo = props.projectInfo;
  const techUsed = projectInfo.techUsed;
  const [h, setH] = useState(0);

  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    function handleResize() {
      setH(document.getElementById("backdropid")?.clientHeight);
    }
    window.addEventListener("resize", handleResize);
  }, []);

  const handleToggle = () => {
    setOpen(!open);
  };

  return (
    <Grid
      container
      style={{
        cursor: open ? "default" : "pointer",
        minHeight: open ? "35em" : "24.1rem",
        height: open ? `${h}px` : null,
        /*backgroundColor: projectInfo.color ? projectInfo.color : null,*/
      }}
      className="projectBox"
      onClick={open ? null : handleToggle}
    >
      <Grid
        style={{
          display: "grid",
          alignContent: "center",
          justifyItems: "center",
          gridTemplateAreas: `"img" "title"`,
          gridTemplateRows: "65% 35%",
        }}
      >
        <Grid item style={{ overflow: "hidden", alignSelf: "center" }}>
          {projectInfo.image.includes("MITM") ||
          projectInfo.image.includes("moc") ||
          projectInfo.image.includes("alinma") ? (
            <img
              style={{
                width: "80%",
              }}
              src={projectInfo.image}
              alt=""
            />
          ) : (
            <video autoPlay loop muted className="videoBox">
              <source src={projectInfo.image} type="video/mp4" />
            </video>
          )}
        </Grid>
        <Grid
          style={{ textAlign: "center", width: "100%", padding: "1rem" }}
          item
        >
          <span className="projectTitle">{projectInfo.title}</span>
        </Grid>
      </Grid>
      <Backdrop className={classes.backdrop} open={open}>
        <div id="backdropid">
          <Grid
            container
            spacing={1}
            direction="row"
            alignItems="center"
            justify="center"
          >
            <Grid item md={12} sm={12} xs={12}>
              <CloseIcon
                onClick={handleToggle}
                style={{
                  position: "absolute",
                  top: 15,
                  right: 10,
                  cursor: "pointer",
                }}
              />
            </Grid>

            <Grid item md={12} sm={12} xs={12}>
              <h2 className="title">{projectInfo.title}</h2>
            </Grid>

            <Grid item md={12} sm={12} xs={12}>
              <p className="description">{projectInfo.descr}</p>
            </Grid>

            {techUsed.map((tech) => (
              <Grid item key={tech}>
                <p className="techs">{tech}</p>
              </Grid>
            ))}
            <Grid item md={12} sm={12} xs={12}>
              <div style={{ marginTop: "15px" }}>
                {projectInfo.live ? (
                  <Button
                    className="boxButton"
                    href={projectInfo.live}
                    target="_blank"
                  >
                    View Live
                  </Button>
                ) : null}

                {projectInfo.github ? (
                  <Button
                    className="boxButton"
                    href={projectInfo.github}
                    target="_blank"
                  >
                    GITHUB
                  </Button>
                ) : null}
              </div>
            </Grid>
          </Grid>
        </div>
      </Backdrop>
    </Grid>
  );
}
